import { Theme, css } from '@emotion/react';

export const popoverRoot = ({ colors, spacing }: Theme) => css`
  .MuiPaper-root {
    border: 1px solid ${colors.borderDefault};
    padding: ${spacing(2)}px;
  }
`;
